<template>
  <main>
    <header>
      <div></div>
      <Transition name="fade">
        <button
          class="btn btn-new"
          @click="createRole()"
          v-if="!hasNotConfirmedRole"
        >
          <span class="mck">L</span>
          ДОБАВИ РОЛЯ
        </button>
      </Transition>
    </header>
    <Transition name="fade" mode="out-in">
      <main v-if="totalRoles.length" class="roles">
        <aside>
          <header class="main-header">Раздели/подраздели</header>
          <section
            class="tab-content"
            v-for="(tab, tabIndex) in tabsData"
            :key="tabIndex"
          >
            <div
              class="tab-name"
              :style="{
                background: tab.color,
              }"
            >
              {{ tab.name }}
            </div>
            <section>
              <div
                :style="{
                  background: tab.color,
                }"
                v-for="field of tab.fields"
                :key="`${field.value}-${tabIndex}`"
                :id="field.value"
              >
                {{ field.name }}
              </div>
            </section>
          </section>
        </aside>
        <section class="roles-content">
          <div class="roles-header main-header">
            <section>
              <header>Роли - основни</header>
              <section class="roles-wrap">
                <div
                  class="role permission-indicator"
                  :class="[`${mainRole.indicator}-indicator`]"
                  v-for="mainRole of mainRoles"
                  :key="mainRole._id"
                >
                  {{ mainRole.name }}
                </div>
              </section>
            </section>
            <section v-if="extraRoles.length">
              <header>Роли - допълнителни</header>
              <section class="roles-wrap">
                <div
                  class="role role--extra"
                  v-for="(extra, i) of extraRoles"
                  :key="`${extra}-${i}`"
                >
                  <input
                    :class="{ 'input--cofnrim': extra.notConfirmed }"
                    placeholder="Въведи име..."
                    v-model="extra.name"
                    type="text"
                  />

                  <span
                    @click="confirmRole(i)"
                    v-if="extra.notConfirmed"
                    class="mck3"
                    >I</span
                  >
                  <span @click="deleteRole(i)" v-else class="mck delete-icon"
                    >b</span
                  >
                </div>
              </section>
            </section>
          </div>

          <section
            class="cell-wrap"
            v-for="(tab, tabIndex) in tabsData"
            :key="tabIndex"
          >
            <section
              v-for="(field, fieldIndex) in tab.fields"
              :key="fieldIndex"
              :style="{ height: heights[field.value] || 'auto' }"
            >
              <div
                class="cell"
                v-for="(role, roleIndex) of totalRoles"
                :key="tabIndex + '-' + fieldIndex + '-' + role._id"
              >
                <span
                  v-for="action in Object.keys(accessTypes)"
                  :key="action"
                  @click="updateRoleAccess(roleIndex, field, action)"
                  class="mck3"
                  :class="[
                    `mck3 mck3--${action}`,
                    { 'mck3--active': role.access[field.value] === action },
                  ]"
                >
                  {{ getActionLabel(action, role.access[field.value]) }}
                </span>
              </div>
            </section>
          </section>
        </section>
      </main>
    </Transition>
  </main>
</template>

<script>
import tabsData from "../data/tabsData";
import tabValues from "../data/tabValues";
import { mapGetters } from "vuex";
import { getAccess } from "./mixins/getAccess";
export default {
  data() {
    return {
      tabsData,
      tabValues,
      heights: {},
      mainRoles: [],
      extraRoles: [],
      hasNotConfirmedRole: false,
      accessTypes: {
        none: { active: "F", inactive: "E" },
        view: { active: "B", inactive: "A" },
        edit: { active: "D", inactive: "C" },
      },
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
    totalRoles() {
      let arr = this.mainRoles.concat(this.extraRoles);
      return arr;
    },
  },
  methods: {
    calculateHeights() {
      this.$nextTick(() => {
        Object.values(this.tabsData).forEach((tab) => {
          tab.fields.forEach((field) => {
            const element = document.getElementById(field.value);

            if (element) {
              const height = Number(element.getBoundingClientRect().height);
              this.$set(this.heights, field.value, `${height.toFixed(2)}px`);
            }
          });
        });
      });
    },
    async getRoles() {
      try {
        this.mainRoles = [];
        this.extraRoles = [];

        let mainRoles = await this.$http.get(
          `${process.env.VUE_APP_BASE_URI}/roles?isMain=true`
        );
        let extraRoles = await this.$http.get(
          `${process.env.VUE_APP_BASE_URI}/roles?isMain=false`
        );
        this.mainRoles = mainRoles.data;
        this.extraRoles = extraRoles.data;
        this.hasNotConfirmedRole = extraRoles.data.some((r) => r.notConfirmed);

        this.calculateHeights();
      } catch (err) {
        console.log(err);
      }
    },
    async createRole() {
      if (getAccess("users_roles", "users", true)) {
        try {
          let role = { notConfirmed: true };

          await this.$http.post(`${process.env.VUE_APP_BASE_URI}/roles`, role);
          await this.getRoles();
        } catch (err) {
          console.log(err);
        }
      }
    },
    async updateRoleAccess(index, field, value) {
      let role = { ...this.totalRoles[index] };
      role.access[field.value] = value;

      const { inventory, users, companies } = this.tabValues;

      const lpsOwn = inventory.LPS_OWN;
      const lpsAll = inventory.LPS_ALL;
      const usersOwnInventory = users.USERS_INVENTORY_OWN;
      const usersAllInventory = users.USERS_INVENTORY_ALL;

      if (field.value === lpsOwn || field.value === usersOwnInventory) {
        // lps own
        role.access[lpsOwn] = value;
        role.access[usersOwnInventory] = value;
      } else if (field.value === lpsAll || field.value === usersAllInventory) {
        // lps all
        role.access[lpsAll] = value;
        role.access[usersAllInventory] = value;
      }

      const companyTabs = [
        companies.MECHANIZATION_TAB,
        companies.PRODUCTION_TAB,
        companies.CONSTRUCTION_TAB,
      ];

      // update the reporters from all the projects of the company
      if (companyTabs.includes(field.value)) {
        await this.updateCompanyReporters(role._id, value, field.value);
      }

      await this.updateRole(role);
    },
    async updateCompanyReporters(role, value, company) {
      try {
        const { companies } = this.tabValues;

        const companyId = {
          [companies.MECHANIZATION_TAB]: "5eaea6bef68f8a150bb1b3b2",
          [companies.PRODUCTION_TAB]: "5eddd7525464233320ad4d91",
          [companies.CONSTRUCTION_TAB]: "5eabbdb1f68f8a150bb1a744",
        };

        let url = `${process.env.VUE_APP_BASE_URI}/company/update-reporters/${companyId[company]}`;

        url += `?role=${role}`;
        url += `&value=${value}`;
        url += `&company=${company}`;

        await this.$http.put(url);
      } catch (err) {
        console.log(err);
      }
    },
    getActionLabel(action, currentAction) {
      return currentAction === action
        ? this.accessTypes[action].active
        : this.accessTypes[action].inactive;
    },
    async updateRole(role) {
      try {
        await this.$http.put(
          `${process.env.VUE_APP_BASE_URI}/roles/${role._id}`,
          role
        );

        await this.getRoles();
      } catch (err) {
        console.log(err);
      }
    },
    async confirmRole(index) {
      try {
        let extraRole = this.extraRoles[index];
        if (!extraRole.name) {
          this.$snotify.error("Моля въведете име на новата роля!");
          return;
        }

        extraRole.notConfirmed = false;

        this.updateRole(extraRole);
      } catch (err) {
        console.log(err);
      }
    },
    async deleteRole(index) {
      try {
        let extraRole = this.extraRoles[index];

        await this.$http.delete(
          `${process.env.VUE_APP_BASE_URI}/roles/${extraRole._id}`
        );

        await this.getRoles();
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          this.$snotify.error(err.response.data.message);
        } else {
          console.log(err);
        }
      }
    },
    handleResize() {
      this.calculateHeights();
    },
  },
  mounted() {
    this.getRoles();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped lang="scss">
.roles {
  display: flex;
  overflow: auto;
  max-height: calc(100vh - 150px);

  aside,
  .roles-content {
    display: flex;
    flex-direction: column;
    gap: 5px;

    header {
      font-size: 13px;
      font-weight: bold;
      background: #f0f0f7;
    }

    .main-header {
      min-height: 55px;
      max-height: 55px;
    }
  }

  aside {
    background: #ffffff;
    position: sticky;
    left: 0;
    z-index: 5;

    header {
      justify-content: center;
    }

    .tab-content {
      display: flex;

      .tab-name {
        align-items: center;
        border: 1px solid #707070;
        border-left: none;
        border-radius: 0 4px 4px 0;
        display: flex;
        padding: 10px;
        font-weight: bold;
        justify-content: center;
        transform: rotate(-180deg);
        text-orientation: mixed;
        writing-mode: vertical-lr;
      }

      > section {
        display: flex;
        flex-direction: column;

        div {
          border: 1px solid #707070;
          font-size: 11px;
          height: 100%;
          // min-height: 36px;
          // max-height: 36px;
          padding: 10px;
          width: 355px;
          // white-space: nowrap;
        }
      }
    }
  }

  .roles-content {
    height: 100%;
    // helps with smoother scrolling
    transform: translateZ(0);

    .roles-header {
      background: #ffffff;
      display: flex;
      position: sticky;
      top: 0;
      z-index: 4;

      .roles-wrap {
        display: flex;
      }
    }

    .role {
      min-width: 120px;
      margin: initial;
      text-align: center;
      min-height: 24px;
      position: sticky;
      top: 0;
      width: 120px;
      z-index: 4;

      &.permission-indicator {
        border: initial;
        border-left: 1px solid #f0f0f7;
        border-right: 1px solid #f0f0f7;
        border-radius: initial;
      }

      &.role--extra {
        position: relative;

        input {
          background: #ffffff;
          border: 1px solid #707070;
          height: 100%;
          padding: 0 30px 0 5px;
          transition: 0.3s all;

          &.input--cofnrim {
            background: #d3e2fb;
            border: 1px solid #3b86ff;
          }
        }
        > span {
          cursor: pointer;
          color: #129123;
          position: absolute;
          right: 5px;
          font-size: 15px;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 1;

          &.delete-icon {
            color: rgba(0, 0, 0, 0.5);
          }
        }
      }
    }

    .cell-wrap {
      display: flex;
      flex-direction: column;

      > section {
        display: flex;
      }
    }

    .cell {
      align-items: center;
      background: #f0f0f7;
      border: 1px solid #707070;
      display: flex;
      gap: 10px;
      // min-height: 36px;
      // max-height: 36px;
      justify-content: center;
      width: 120px;

      .mck3 {
        cursor: pointer;
        font-size: 24px;
        opacity: 0.5;

        &.mck3--active {
          opacity: 1;
        }

        &.mck3--none {
          color: #cf1313;
        }
        &.mck3--view {
          color: #3b86ff;
        }
        &.mck3--edit {
          color: #38a910;
        }
      }
    }
  }
}
</style>